var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "VTN:",
                  content: _vm.dadosJson.avaliacaoImovel.vtn || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Valor das Benfeitorias Reprodutivas:",
                  content:
                    _vm.dadosJson.avaliacaoImovel
                      .valorBenfeitoriasReprodutivas || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Valor das Benfeitorias Não Reprodutivas:",
                  content:
                    _vm.dadosJson.avaliacaoImovel
                      .valorBenfeitoriasNaoReprodutivas || "-"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Intimação de Valores:",
                  content: _vm.dadosJson.avaliacaoImovel.intimacaoValores || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Contrapropostas:",
                  content: _vm.dadosJson.avaliacaoImovel.contraPropostas || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "CAU/ART:",
                  content: _vm.dadosJson.avaliacaoImovel.cauArt || "-"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.dadosJson.avaliacaoImovel.documentosLaudo
        ? _c("listagem-documentos", {
            attrs: {
              documentos: _vm.dadosJson.avaliacaoImovel.documentosLaudo,
              protocoloCadastroOriginal: _vm.dadosJson.protocolo,
              ownerDocumento: "AVALIACAO_IMOVEL_LAUDO",
              compararDocumentos: null,
              versaoCadastro: null
            }
          })
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "labelStyle mt-30px" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Nome do Responsável:",
                  content:
                    _vm.dadosJson.georreferenciamento.responsavel.nome || "-"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Matrícula do Responsável:",
                  content:
                    _vm.dadosJson.georreferenciamento.responsavel.matricula ||
                    "-"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.dadosJson.georreferenciamento.documentos
        ? _c("listagem-documentos", {
            attrs: {
              documentos: _vm.dadosJson.georreferenciamento.documentos,
              protocoloCadastroOriginal: _vm.dadosJson.protocolo,
              ownerDocumento: "GEORREFERENCIAMENTO",
              compararDocumentos: null,
              versaoCadastro: null
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c77eaeae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c77eaeae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/AvaliacaoRf.vue
// module id = null
// module chunks = 